import { Component, OnInit } from '@angular/core';
import { CURRENT_POLICY, USER_ID } from '@prcins/constants';
import { EdocsBroadcasterService, UtilityProviderService, INotification } from '@prcins/utils';
import { NotificationService } from '../notification.service';

@Component({
  selector: 'prcins-edocs-signup',
  templateUrl: './edocs-signup.component.html',
  styleUrls: ['./edocs-signup.component.css']
})
export class EdocsSignupComponent implements OnInit {
  showSignUp = true;
  isLoading = false;
  edocsEnrollmentNotification: INotification;

  constructor(
    private eb: EdocsBroadcasterService,
    private utilityProvider: UtilityProviderService
  ) { }

  ngOnInit() { }

  onSignUp() {
    this.isLoading = true;
    const policyNumber = sessionStorage.getItem(CURRENT_POLICY);
    const email = sessionStorage.getItem(USER_ID);
    const userId = sessionStorage.getItem(USER_ID);

    this.utilityProvider
      .eDiscloserAudit({
        policyNumber,
        agreementType: 'EDOCENROLL',
        agreementType2: 'ELECTRONICCONSENT',
        source: 'ESERVICE',
        email
      }).subscribe();

    this.utilityProvider.signupForEdocs(policyNumber, email).subscribe(
      (val: any) => {
        if (!val.errorMsg) {
          this.eb.notify$.next({ type: 'INFO', message: 'Congratulations! You have successfully changed your eDoc preferences.' });
          const accounts = this.eb.getEdocs(userId);
          if (accounts) {
            for (let i = 0; i < accounts.account.edocs.length; i++) {
              if (accounts.account.edocs[i].policyNumber === policyNumber) {
                accounts.account.edocs[i].emailAddress = userId;
                accounts.account.edocs[i].subscriptionFlag = 'Y';
                break;
              }
            }
            this.eb.updateEdocs(userId, accounts);
          }
          this.eb.updateShowEdocs(policyNumber, false);
          setTimeout(() => {
            this.showSignUp = false;
          }, 5000);
        } else if (val.errorMsg === 'edocs.update.success') {
          this.eb.notify$.next({ type: 'INFO', message: 'Congratulations! You have successfully changed your eDoc preferences.' });
        } else if (val.errorMsg === 'zip.mismatch') {
          this.eb.notify$.next({ type: 'ERROR', message: 'We are unable to find an account for the information you provided. Please make sure the information is correct. If you still cannot sign up, please contact us.' });
        } else if (val.errorMsg === 'alreadySigned') {
          this.eb.notify$.next({ type: 'ERROR', message: 'You have already signed up for eDocuments!' });
        } else {
          this.eb.notify$.next({ type: 'ERROR', message: 'Oops! We seem to be having a problem. Please try again later or contact us for help.' });
        }
        this.isLoading = false;
      },
      () => {
        this.isLoading = false;
        this.eb.notify$.next({ type: 'ERROR', message: 'Oops! We seem to be having a problem. Please try again later or contact us for help.' });
      }
    );
  }
}
